import {Fragment} from "react";
import useVisitedPage from "../hooks/visitedpage/useVisitedPage";

export default function VisitedPageListener() {
    useVisitedPage();
    return <Fragment/>
}